import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.states';
import { UsersSelectors } from 'src/app/features/users/state/users.selector-types';
import { UsersService } from 'src/app/features/users/services/users.service';
import { UsersActions } from 'src/app/features/users/state/users.action-types';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-client-contract-dialog',
  templateUrl: './client-contract-dialog.component.html',
  styleUrls: ['./client-contract-dialog.component.scss'],
})
export class ClientContractDialogComponent implements OnInit, OnDestroy {
  ngUnsubscribe: Subject<void> = new Subject<void>();
  profile: any;
  contractUrl: string = 'https://finsmart.pe/legal';

  constructor(
    private store: Store<AppState>,
    private usersService: UsersService,
    public dialogRef: MatDialogRef<ClientContractDialogComponent>
  ) {}

  ngOnInit(): void {
    this.store
      .select(UsersSelectors.profile())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(profile => {
        if (profile) {
          this.profile = profile;
        }
      });
  }

  close(): void {
    this.markContractAsSeen();
  }

  onLinkClick(event: Event): void {
    event.preventDefault();
    window.open(this.contractUrl, '_blank');
    this.markContractAsSeen();
  }

  private markContractAsSeen(): void {
    this.usersService.markContractAsSeen().subscribe({
      next: () => {
        console.log('Contract marked as seen');
        this.store.dispatch(UsersActions.LoadProfile());
        this.dialogRef.close();
      },
      error: err => {
        console.error('Error marking contract as seen:', err);
        this.dialogRef.close();
      },
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
